import DocumentationProcessSimplifiedBanner from './DocumentationProcessSimplifiedBanner';
import DocumentationProcessSimplifiedSection from './DocumentationProcessSimplifiedSection';

function DocumentationProcessSimplified() {
  return (
    <div>
      <DocumentationProcessSimplifiedBanner />
      <DocumentationProcessSimplifiedSection />
    </div>
  );
}

export default DocumentationProcessSimplified;